import { gql } from '@apollo/client'

export default gql`
  mutation updatePayment($paymentId: String!, $cartInfo: CartInfo!, $mfKey: String!, $ecToken: String) {
    updatePayment(paymentId: $paymentId, cartInfo: $cartInfo, mfKey: $mfKey, ecToken: $ecToken) {
      ecToken
      paymentId
      promotionSoldOutErrors {
        sku
      }
    }
  }
`
